import React, { createContext, useCallback, useContext, useState } from 'react';
import { v4 as uuid } from 'uuid';

import ToastContainer from '../components/ToastContainer';

export interface ToastMessage {
  id: string;
  type: 'success' | 'error' | 'info';
  title: string;
  description?: string;
}
type AuthContextProps = {
	children: React.ReactNode;
}
interface ToastContextData {
  addToast(message: Omit<ToastMessage, 'id'>): void;
  removeToast(id: string): void;
}

const ToastContext = createContext<ToastContextData>({} as ToastContextData);

const ToastProvider: React.FC<AuthContextProps> = ({ children }) => {
  const [messages, setMessages] = useState<ToastMessage[]>([]);

  // const addToast = useCallback(({ type, title, description }: Omit<ToastMessage, 'id'>) => {
	async function addToast({ type, title, description }: Omit<ToastMessage, 'id'>) {
		const id = uuid();

		const toast = { id, type, title, description };

		setMessages(oldMessages => [...oldMessages, toast]);
	};// ,[]);

  // const removeToast = useCallback((id: string) => {
	async function removeToast(id: string) {
    setMessages(state => state.filter(message => message.id !== id));
  }; //, []);

  return (
    <ToastContext.Provider value={{ addToast, removeToast }}>
      {children}
      <ToastContainer messages={messages} />
    </ToastContext.Provider>
  );
};

function useToast(): ToastContextData {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export { ToastProvider, useToast };
